import React from 'react';
import { connect } from 'react-redux';
import {
  getIdOfSelectedSpecimen,
  getBoundsForSpecimenImage,
  getRotationForSpecimenImage,
} from '../../redux/reducers';
import { CaseSpecimenOpenSeadragon } from '..';

const mapStateToProps = (state) => {
  const { mpp } = state.cadessData;
  const idOfSelectedSpecimen = getIdOfSelectedSpecimen(state);
  return {
    mpp: mpp,
    imageBounds: getBoundsForSpecimenImage(state, idOfSelectedSpecimen),
    imageRotation: getRotationForSpecimenImage(state, idOfSelectedSpecimen),
  };
};

const SpecimenImage = ({
  specimenId,
  imgUrl,
  mpp,
  cadessImgUrl,
  imageBounds,
  imageRotation,
  cadessOverlayIsVisible,
  openSeadragonShouldBeRendered,
  cadessStatus,
}) => {
  /**
   * @todo Implement error handling if imgUrl is not
   * valid as argument for `OpenSeadragon.tileSources`
   */
  const imgUrlToPassAsProp = imgUrl.length ? imgUrl : {
    type: 'image',
    url: 'https://upload.wikimedia.org/wikipedia/commons/1/1f/Vacuolar_myopathy_mcArdle_type_V_glcogenosis.jpg',
    ajaxWithCredentials: false,
  };
  return (
    <CaseSpecimenOpenSeadragon
      cadessStatus={cadessStatus}
      specimenId={specimenId}
      imgUrl={imgUrlToPassAsProp}
      mpp={mpp}
      cadessImgUrl={cadessImgUrl}
      imageBounds={imageBounds}
      imageRotation={imageRotation}
      cadessOverlayIsVisible={cadessOverlayIsVisible}
      openSeadragonShouldBeRendered={openSeadragonShouldBeRendered}
    />
  );
};

export default connect(mapStateToProps)(SpecimenImage);
